// extracted by mini-css-extract-plugin
export default {"description":"EditableDescription_description__SySB6"};